
const classIdAliasMap = {};
    classIdAliasMap["NaturalRiskZone"] = 606010101
    classIdAliasMap["NaturalRiskZoneGeological"] = 606010102
    classIdAliasMap["NaturalRiskZoneHydrological"] = 606010103
    classIdAliasMap["NaturalRiskZoneMeteorological"] = 606010104
    classIdAliasMap["TechoRiskZone"] = 606010201
    classIdAliasMap["TechoRiskZoneRadioactive"] = 606010202
    classIdAliasMap["TechoRiskZoneChemical"] = 606010203
    classIdAliasMap["TechoRiskZoneHydrodynamical"] = 606010204
    classIdAliasMap["HighwaysFederal"] = 602030301
    classIdAliasMap["HighwaysRegional"] = 602030302
    classIdAliasMap["HighwaysLocal"] = 602030303
    classIdAliasMap["HighwaysPrivate"] = 602030304
    classIdAliasMap["ElectricalSubstations1150"] = 602040201
    classIdAliasMap["ElectricalSubstations800"] = 602040202
    classIdAliasMap["ElectricalSubstations750"] = 602040203
    classIdAliasMap["ElectricalSubstations600"] = 602040204
    classIdAliasMap["ElectricalSubstations500"] = 602040205
    classIdAliasMap["ElectricalSubstations400"] = 602040206
    classIdAliasMap["ElectricalSubstations330"] = 602040207
    classIdAliasMap["ElectricalSubstations300"] = 602040208
    classIdAliasMap["ElectricalSubstations220"] = 602040209
    classIdAliasMap["ElectricalSubstations150"] = 602040210
    classIdAliasMap["ElectricalSubstations110"] = 602040211
    classIdAliasMap["ElectricalSubstations60"] = 602040212
    classIdAliasMap["ElectricalSubstations35"] = 602040213
    classIdAliasMap["ElectricalSubstations20"] = 602040214
    classIdAliasMap["ElectricalSubstations10"] = 602040215
    classIdAliasMap["ElectricalSubstations6"] = 602040216
    classIdAliasMap["ElectricalSubstationsTransformer"] = 602040217
    classIdAliasMap["ElectricalSubstationsDistributionPoint"] = 602040218
    classIdAliasMap["ElectricalSubstations400Transformative"] = 602040221
    classIdAliasMap["ElectricalSubstationsTractionRailway"] = 602040222
    classIdAliasMap["ElectricalSubstationsSwitchingPoint"] = 602040223
    classIdAliasMap["ElectricalSubstationsDCInsertion"] = 602040224
    classIdAliasMap["ElectricalSubstationsConnectingPoint"] = 602040225
    classIdAliasMap["PowerLines1150"] = 602040301
    classIdAliasMap["PowerLines800"] = 602040302
    classIdAliasMap["PowerLines750"] = 602040303
    classIdAliasMap["PowerLines600"] = 602040304
    classIdAliasMap["PowerLines500"] = 602040305
    classIdAliasMap["PowerLines400"] = 602040306
    classIdAliasMap["PowerLines330"] = 602040307
    classIdAliasMap["PowerLines300"] = 602040308
    classIdAliasMap["PowerLines220"] = 602040309
    classIdAliasMap["PowerLines150"] = 602040310
    classIdAliasMap["PowerLines110"] = 602040311
    classIdAliasMap["PowerLines60"] = 602040312
    classIdAliasMap["PowerLines35"] = 602040313
    classIdAliasMap["PowerLines20"] = 602040314
    classIdAliasMap["PowerLines10"] = 602040315
    classIdAliasMap["PowerLines6"] = 602040316

const classIdMap = [{
    classId: classIdAliasMap.TechoRiskZone,
    label: "Территории, подверженные риску возникновения чрезвычайных ситуаций техногенного характера"
}, {
    classId: classIdAliasMap.TechoRiskZoneRadioactive,
    label: "Зона, подверженная риску радиоактивного загрязнения"
}, {
    classId: classIdAliasMap.TechoRiskZoneChemical,
    label: "Зона, подверженная риску химического заражения"
}, {
    classId: classIdAliasMap.TechoRiskZoneHydrodynamical,
    label: "Зона возможного катастрофического затопления (при аварии на гидродинамически опасном объекте)"
}, {
    classId: classIdAliasMap.NaturalRiskZone,
    label: "Территории, подверженные риску возникновения чрезвычайных ситуаций природного характера"
}, {
    classId: classIdAliasMap.NaturalRiskZoneGeological,
    label: "Территории, подверженные опасным геологическим процессам"
}, {
    classId: classIdAliasMap.NaturalRiskZoneHydrological,
    label: "Территории, подверженные опасным гидрологическим процессам"
}, {
    classId: classIdAliasMap.NaturalRiskZoneMeteorological,
    label: "Территории, подверженные опасным метеорологическим процессам"
}, {
    classId: classIdAliasMap.HighwaysFederal,
    label: "Автомобильные дороги федерального значения"
}, {
    classId: classIdAliasMap.HighwaysRegional,
    label: "Автомобильные дороги регионального или межмуниципального значения"
}, {
    classId: classIdAliasMap.HighwaysLocal,
    label: "Автомобильные дороги местного значения"
}, {
    classId: classIdAliasMap.HighwaysPrivate,
    label: "Частные автомобильные дороги"
}, {
    classId: classIdAliasMap.ElectricalSubstations1150,
    label: "Электрическая подстанция 1150 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations800,
    label: "Электрическая подстанция 800 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations750,
    label: "Электрическая подстанция 750 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations600,
    label: "Электрическая подстанция 600 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations500,
    label: "Электрическая подстанция 500 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations400,
    label: "Электрическая подстанция 400 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations330,
    label: "Электрическая подстанция 330 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations300,
    label: "Электрическая подстанция 300 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations220,
    label: "Электрическая подстанция 220 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations150,
    label: "Электрическая подстанция 150 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations110,
    label: "Электрическая подстанция 110 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations60,
    label: "Электрическая подстанция 60 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations35,
    label: "Электрическая подстанция 35 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations20,
    label: "Электрическая подстанция 20 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations10,
    label: "Электрическая подстанция 10 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstations6,
    label: "Электрическая подстанция 6 кВ"
}, {
    classId: classIdAliasMap.ElectricalSubstationsTransformer,
    label: "Трансформаторная подстанция (ТП)"
}, {
    classId: classIdAliasMap.ElectricalSubstationsDistributionPoint,
    label: "Распределительный пункт (РП)"
}, {
    classId: classIdAliasMap.ElectricalSubstations400Transformative,
    label: "Электрическая подстанция 400 кВ преобразовательная"
}, {
    classId: classIdAliasMap.ElectricalSubstationsTractionRailway,
    label: "Тяговая подстанция (железной дороги)"
}, {
    classId: classIdAliasMap.ElectricalSubstationsSwitchingPoint,
    label: "Переключательный пункт"
}, {
    classId: classIdAliasMap.ElectricalSubstationsDCInsertion,
    label: "Вставка постоянного тока"
}, {
    classId: classIdAliasMap.ElectricalSubstationsConnectingPoint,
    label: "Соединительный пункт"
}, {
    classId: classIdAliasMap.PowerLines1150,
    label: "Линии электропередачи 1150 кВ"
}, {
    classId: classIdAliasMap.PowerLines800,
    label: "Линии электропередачи 800 кВ"
}, {
    classId: classIdAliasMap.PowerLines750,
    label: "Линии электропередачи 750 кВ"
}, {
    classId: classIdAliasMap.PowerLines600,
    label: "Линии электропередачи 600 кВ"
}, {
    classId: classIdAliasMap.PowerLines500,
    label: "Линии электропередачи 500 кВ"
}, {
    classId: classIdAliasMap.PowerLines400,
    label: "Линии электропередачи 400 кВ"
}, {
    classId: classIdAliasMap.PowerLines330,
    label: "Линии электропередачи 330 кВ"
}, {
    classId: classIdAliasMap.PowerLines300,
    label: "Линии электропередачи 300 кВ"
}, {
    classId: classIdAliasMap.PowerLines220,
    label: "Линии электропередачи 220 кВ"
}, {
    classId: classIdAliasMap.PowerLines150,
    label: "Линии электропередачи 150 кВ"
}, {
    classId: classIdAliasMap.PowerLines110,
    label: "Линии электропередачи 110 кВ"
}, {
    classId: classIdAliasMap.PowerLines60,
    label: "Линии электропередачи 60 кВ"
}, {
    classId: classIdAliasMap.PowerLines35,
    label: "Линии электропередачи 35 кВ"
}, {
    classId: classIdAliasMap.PowerLines20,
    label: "Линии электропередачи 20 кВ"
}, {
    classId: classIdAliasMap.PowerLines10,
    label: "Линии электропередачи 10 кВ"
}, {
    classId: classIdAliasMap.PowerLines6,
    label: "Линии электропередачи 6 кВ"
}].reduce((acc, red) => {
    acc[red.classId.toString()] = red.label;
    return acc;
}, {});

const statusAliasMap = {};
    statusAliasMap["ExistingAndReconstructedUnderConstruction"] = 1
    statusAliasMap["PlannedForPlacement"] = 2
    statusAliasMap["PlannedForReconstruction"] = 3
    statusAliasMap["PlannedForLiquidation"] = 4

const statusMap = [{
    status: statusAliasMap.ExistingAndReconstructedUnderConstruction,
    label: "Существующий, реконструируемый, строящийся"
}, {
    status: statusAliasMap.PlannedForPlacement,
    label: "Планируемый к размещению"
}, {
    status: statusAliasMap.PlannedForReconstruction,
    label: "Планируемый к реконструкции"
}, {
    status: statusAliasMap.PlannedForLiquidation,
    label: "Планируемый к ликвидации"
}].reduce((acc, red) => {
    acc[red.status.toString()] = red.label;
    return acc;
}, {});

const regStatusAliasMap = {};
    regStatusAliasMap["Federal"] = 1
    regStatusAliasMap["Regional"] = 2
    regStatusAliasMap["LocalMunicipalArea"] = 3
    regStatusAliasMap["LocalDistrict"] = 4
    regStatusAliasMap["LocalSettlement"] = 5
    regStatusAliasMap["Other"] = 6

const regStatusMap = [{
    status: regStatusAliasMap.Federal,
    label: "Федеральное значение"
}, {
    status: regStatusAliasMap.Regional,
    label: "Региональное значение"
}, {
    status: regStatusAliasMap.LocalMunicipalArea,
    label: "Местное значение муниципального района"
}, {
    status: regStatusAliasMap.LocalDistrict,
    label: "Местное значение городского округа"
}, {
    status: regStatusAliasMap.LocalSettlement,
    label: "Местное значение поселения"
}, {
    status: regStatusAliasMap.Other,
    label: "Иное значение"
}].reduce((acc, red) => {
    acc[red.status.toString()] = red.label;
    return acc;
}, {});

export {
    statusMap,
    classIdMap,
    regStatusMap,
    statusAliasMap,
    regStatusAliasMap,
    classIdAliasMap
}